<template>
  <div class="airST-conditional modal in" style="display: block;">
    <div class="sp_w100p">
      <div class="modal-content">
        <tk-button
          class="btn filter-btn w100p"
          style="text-align: left;"
          @click="close"
        >
          <i class="fa fa-arrow-left"></i>&nbsp;戻る
        </tk-button>
        <div class="airST-conditional_sp renew pd10">
          <tk-hotel-filter
            :selected-filter-options="selectedFilter"
            :filter-list="filterList"
            :key-word="hotelName"
            @filter="handleSelectedFilter"
            @filter-name="handleFilterHotelName"
          />
        </div>
        <div class="modal-footer">
          <div class="col-xs-12 text-center m-auto">
            <button class="btn btn-block btn-danger" @click="doFilter">
              <i aria-hidden="true" class="fa fa-search icon-l"></i>
              この条件で絞り込む
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TkButton from '../../atoms/TkButton/TkButton.vue'
import ModalMixin from '../../atoms/TkGlobalModal/modal-mixin'
import TkHotelFilter from './TkHotelFilter'

export default {
  name: 'TkHotelFilterModal',
  components: {
    TkHotelFilter,
    TkButton,
  },
  mixins: [ModalMixin],
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    filterList: {
      type: Array,
      required: true,
    },
    keyWord: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedFilter: this.filters,
      hotelName: this.keyWord,
    }
  },
  methods: {
    handleSelectedFilter(selected) {
      this.selectedFilter = selected
    },
    handleFilterHotelName(obj) {
      this.hotelName = obj.hotelName
    },
    doFilter() {
      this.$emit('filter', this.selectedFilter)
      this.$emit('filter-name', { hotelName: this.hotelName })
      this.close()
    },
  },
}
</script>
